<!--
     <ChartsLayout
       :chartview="{charts: {...}, layout: {...}}"
       class_cont="cl-cont"
       class_chart="cl-chart"
     />
-->

<template>
  <div :class="class_cont">
    <BPIdLayout
      :layout="layout"
      :objects="objects"
    >
      <template v-slot:element="{ data }">
        <!-- <div> {{ 'AAA' + JSON.stringify(data) }}</div> -->
        <Chart
          :class="class_chart"
          :title="data.title"
          :chardata="data.chartdata"
          :type="data.type"
        />
      </template>
    </BPIdLayout>
  </div>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .cl-cont {
   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
 }

 .cl-chart {
   padding: 10px;
   border-radius: 10px;
   border-style: solid;
   border-width: 1px;
   border-color: $primary;
   height: 250px;
 }

 .cl-chart.full {
   width: 100%;
   height: 200px;
 }

 @media all and (orientation:portrait) {
   .cl-chart {
     width: 100% !important;
     /* height: 40vh !important; */
   }
 }
</style>

<script>
 import Chart from '@/components/charts/Chart';
 import BPIdLayout from '@/components/layout/BPIdLayout';

 export default {
   name: 'ExplorerCharts',

   components: {
     BPIdLayout,
     Chart,
   },

   props: {
     chartview: {required: true},
     class_cont: {default: 'cl-cont'},
     class_chart: {default: 'cl-chart'},
   },

   data: (() => ({
     // :)
   })),

   computed: {
     layout() {
       return this.chartview.layout;
     },

     objects() {
       return this.chartview.charts;
     },
   },
 };
</script>
